// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"1f1aa18e","438":"f1d91b28","448":"a8742ecf","603":"53f2db96","668":"721f3921","732":"46bb978d","977":"f2c489be"}[chunkId] + ".chunk.js";
};